export enum ClientGenderType {
  Male = 'Male',
  Female = 'Female',
}
